export default __webpack_public_path__ + "static/media/isabella2.29dd537b.png";